// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_ant-design_icons_es_icons_ArrowDownOutlined_js-node_modules_ant-design_i-213d45":"8b2e3ed2","src_bootstrap_js-src_images_redwood-logo_png":"87329551"}[chunkId] + ".chunk.js";
};